export default __webpack_public_path__ + "static/media/halloween.0535b55d.jpg";